export default __webpack_public_path__ + "static/media/img4.0c83ffab.jpg";